import React from 'react';
import { WpMenu } from '../index';
import ContextNav from './context-nav';

const MainLinks = ({
  props: {
    toggleIssueNavList,
    issueName,
    issueDate,
    issueNavMenuItems,
    publishedIssues,
    showIssueNavList,
    location,
    wpPage,
  },
}) => {
  const contextNav = (
    <ContextNav
      issueName={issueName}
      issueDate={issueDate}
      toggleIssueNavList={toggleIssueNavList}
      showIssueNavList={showIssueNavList}
      publishedIssues={publishedIssues}
    />
  );

  let pageContext;
  switch (location) {
    case 'home':
    case 'documentaries-listing':
      pageContext = contextNav;
      break;
    case 'single-issue':
      pageContext = `${issueName}`;
      break;
    case 'issues-listing':
      pageContext = <h1>Archive</h1>;
      break;
    case 'single-article--article':
      pageContext = 'Article';
      break;
    case 'single-article--documentary':
      pageContext = 'Film';
      break;
    default:
      pageContext = wpPage?.title ? wpPage?.title : wpPage;
  }

  return (
    <>
      <div className="site-header__links-toc">{pageContext}</div>
      {issueNavMenuItems?.nodes && (
        <WpMenu className="site-header__links-menu" menuItems={issueNavMenuItems.nodes} />
      )}
      <a
        href="https://worksinprogress.substack.com/"
        className="site-header__links-subscribe"
        target={`_blank`}
      >
        Subscribe
      </a>
    </>
  );
};

export default MainLinks;
